import React from 'react';
import Text from 'components/Text/Text';
import breadcrumbs from 'images/breadcrumbs.svg';

interface IProps {
	name: string;
}

export const AssignImg: React.FC<IProps> = ({ name }) => {
	return (
		<div className="absolute top-1.5 right-1.5 py-0.5 px-2 flex items-center border border-solid border-blue-600 rounded-xl bg-blue-200">
			<svg className="w-4 h-4 mr-1 pb-[1px] fill-blue-600">
				<use xlinkHref={`${breadcrumbs}#orders`} />
			</svg>
			<Text translationNameSpace="listing" translationKey={name} theme="accent" size="xs" />
		</div>
	);
};
